module.exports = __webpack_public_path__ + "img/minus_btn.f3299d14.png";